<template>
  <div v-loadcover="fetchInProgress" style="min-height: 400px;">
    <StartupProfilePage
      v-show="canSeeProfile"
      :can-user-see-private-data="canUserSeePrivateData"
    />
    <NoProject v-show="!fetchInProgress && !canSeeProfile" />
  </div>
</template>

<script>
import StartupProfilePage from '@/modules/startup-profile/StartupProfilePage'
import NoProject from '@/modules/startup-profile/NoProject'
import { mapState } from 'vuex'

export default {
  components: { StartupProfilePage, NoProject },
  props: {
    slug: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      user: (state) => state.user.data,
      userIsAuthorized: (state) => state.user.isAuthorized,
      startup: (state) => state.startupProfile.startup,
      startupFetchInProgress: (state) => state.startupProfile.fetchInProgress,
      fetchInProgress: (state) =>
        state.startupProfile.fetchInProgress || state.user.fetchInProgress,
    }),
    isOwner() {
      return this.user.isOwner(this.startup.id) || this.user.isOwner(this.slug)
    },
    canSeeProfile() {
      const isOrganizer = this.user.isOrganizer && this.startup.id // isOrganizer alone is not enough as API might still return 403/404
      return (
        this.isOwner ||
        this.user.isAdmin ||
        isOrganizer ||
        this.user.isInvestor ||
        this.startup.is_published
      )
    },
    canUserSeePrivateData() {
      // const canSee = this.userIsAuthorized && this.user.startupId === this.startup.id
      // TODO: temporary for wolves summit we allow investors to review all startups
      // (we have unpublished all existing startups for now)
      const canSee = this.userIsAuthorized
      return canSee
    },
  },
  $pusherHandlers: {
    startup: {
      classified(event) {
        if (event.id === this.startup.id) {
          this.fetchRatings()
        }
      },
      rated(event) {
        if (event.id === this.startup.id) {
          this.fetch({ silent: true })
        }
      },
    },
  },
  async created() {
    if (this.userIsAuthorized) {
      await this.fetch()
      return
    }
    await this.$router.push({
      name: 'login',
      params: { next: this.$route.fullPath },
    })
  },
  methods: {
    async fetch(opts) {
      const showroomId = this.$route.query.showroomId
      await this.$store.dispatch('user/getUser')
      const slug = this.slug
      opts = opts || {}
      const silent = opts.silent
      if (this.isOwner || this.user.isAdmin) {
        await this.$store.dispatch('startupProfile/fetch', { id: slug, silent })
      } else {
        await this.$store.dispatch('startupProfile/fetchPublic', {
          slug,
          silent,
          isAuthorized: this.userIsAuthorized,
          showroomId,
        })
      }
      await this.fetchRatings()
    },
    async fetchRatings() {
      if (
        this.user.isInvestorOrOrganizer &&
        this.user.investor &&
        this.user.investor.id
      ) {
        this.$store.commit(
          'startupProfileInvestorClassifies/enableClassification',
        )
        const investor = this.user.investor
        const investorId = investor.id
        const startupId = this.startup.id
        const state = await this.$store.dispatch(
          'startupProfileInvestorClassifies/getState',
          { startupId, investorId },
        )
        if (state === 'applied' || !state) {
          this.$store.dispatch(
            'startupProfileInvestorClassifies/startScreening',
            { startupId, investorId },
          )
        }
      }
    },
  },
}
</script>
